import { render, staticRenderFns } from "./KazimaPage.vue?vue&type=template&id=0b52d0c1&scoped=true&"
import script from "./KazimaPage.vue?vue&type=script&lang=js&"
export * from "./KazimaPage.vue?vue&type=script&lang=js&"
import style0 from "./KazimaPage.vue?vue&type=style&index=0&id=0b52d0c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b52d0c1",
  null
  
)

export default component.exports